<template>
  <div class="wizard-content">
    <div class="wizard-content__column">
      <!-- <component-data :title="trans.resumeTitle[lang]">
        <cart-component></cart-component>
      </component-data> -->
      <!-- Address From component -->
      <address-form expandable>
        <span>{{ addressForm.personal.name.value }}</span>
        <span>{{ addressForm.personal.address.value }}, {{ addressForm.personal.info.value }}</span>
        <span>{{ addressForm.personal.city.value }}, {{ addressForm.postal.value }} , {{ addressForm.country.value }}</span>
      </address-form>
      <!--              -->
      <!-- Personal Data -->
      <component-data
        :title="trans.get('wizard.contactTitle')"
        expandable
        class="mt-10"

      >
        <form>
            <floating-input
            :placeholder="trans.get(`wizard.${fields.email.name}`)"
            :initialValue="fields.email.value"
            :initialErrors="fields.email.errors"
            @handle-change="handlePersonalChange"
            :type="fields.email.type"
            :name="fields.email.name"
            class="mt-2"
          ></floating-input>
          <div class="flex mt-2">
            <v-select
                class="min-width-8"
                :options="phonePrefixes"
                :placeholder="trans.get('wizard.phone_prefix')"
                @input="handlePhonePrefix"
                :value="fields.phone_prefix.value"
            >
            <template #option="{ label, icon }">
                <div class="flex items-center"><span class="mr-2">{{ label }}</span> <img loading="lazy" class="h-4" :src="`/img/flags/${icon}.png`"></div>
            </template>
            </v-select>
            <floating-input
                :placeholder="trans.get(`wizard.${fields.phone.name}`)"
                :initialValue="fields.phone.value"
                :initialErrors="fields.phone.errors"
                @handle-change="handlePersonalChange"
                :type="fields.phone.type"
                class="ml-4 w-full"
                :name="fields.phone.name"
            ></floating-input>
          </div>
          <floating-input
                v-if="isCanarias"
                :placeholder="trans.get(`wizard.${fields.dni.name}`)"
                :initialValue="fields.dni.value"
                :initialErrors="fields.dni.errors"
                @handle-change="handlePersonalChange"
                :type="fields.dni.type"
                :name="fields.dni.name"
                class="lg:ml-4 mt-2 w-full"
            ></floating-input>
        </form>
        <template v-slot:minimized-slot>
          <span>{{ personalData.email.value }}</span>
          <span>{{ personalData.phone_prefix.value}} {{ personalData.phone.value }}</span>
        </template>
      </component-data>
      <!-- Shipment component -->
      <component-data :title="trans.get('wizard.shipmentTitle')" disabled class="mt-10">
        <div class="shipment-container no-input">
          <div for="standard" class="w-full">
            <div class="shipment-container__label">
              <div class="in-row">
                <span>Standard</span>
                <span>{{ shippingType.cost | currency }}</span>
              </div>
            </div>
          </div>
        </div>
      </component-data>
      <!-- Products component -->
      <component-data :title="trans.get('wizard.productsTitle')" class="mt-10" iconType="arrow" expandable first-expanded>
        <div class="shipment-container no-input">
          <div class="w-full">
            <div v-for="item in items" :key="item.id" class="shipment-container__label">
              <div class="in-row my-3 text-base">
                <span>{{item.quantity}} x {{ item.name[lang] || item.name.en }} - {{ item.attributes.description }}</span>
                <span>{{ itemFinalPrice(item) | currency }}</span>
              </div>
              <promotion-card class="flex justify-between mb-1 ml-2 text-sm" v-if="showPromotionItem(item)"
                :promotion-description="promotionDescription(item)" :promotion-image="item.attributes.promotion?.image" :promotion-info="promotionInfo(item)"></promotion-card>
            </div>
          </div>
        </div>
      </component-data>
    </div>
    <div class="wizard-content__column">
      <component-data :title="trans.get('wizard.promotiontitle')">
        <discount-component v-if="!isDiscountActive && !anyPromotionActive"></discount-component>
        <div class="mb-5" v-else>
          <p>{{trans.get('wizard.couponIsNotAvailable')}}</p>
        </div>
      </component-data>
      <!-- Newsletter component -->
      <component-data :title="trans.get('wizard.newsletter.newsletter')">
        <div class="flex flex-col gap-4 mb-8">
          <p class="mt-3 font-semibold" >{{ trans.get('wizard.newsletter.title') }}</p>
          <div class="flex items-center">
            <input class="check-newsletter" type="checkbox" name="newsletter" v-model="newsletterChecked">
            <p class="ml-3 font-semibold" >{{ trans.get('wizard.newsletter.checkbox') }}</p>
          </div>
          <div class="flex flex-col"> 
            <privacy-route
              :privacy-policy-url="trans.get('routes.legal.privacy-policy')"
            ></privacy-route>
            <p class="text-xs">{{ trans.get('wizard.newsletter.unsubscribe') }}</p>
          </div>
      </div>
      </component-data>
      <!-- Payment methods component -->
      <component-data :title="trans.get('wizard.paymentMethod')">
        <div class="payments-container">
          <div class="radio-input">
            <div class="flex items-center">
              <input
                type="radio"
                id="paragon"
                value="paragon"
                v-model="paymentMethod"
              />
              <label for="paragon" class="w-full pl-3 font-bold">
                <div class="payments-container__label">
                  <div class="in-row">
                    <span>{{ trans.get('wizard.paymentcard_title') }}</span>
                  </div>
                </div>
              </label>
            </div>
            <div class="pl-6 mt-2">
              <p>{{ trans.get('wizard.paymentcard_description') }}</p>
              <!-- <transition name="fade">
                <card-component v-if="paymentMethod == 'paragon'">
                </card-component>
              </transition> -->
            </div>
          </div>
          <!-- <div class="radio-input">
            <div class="flex items-center">
              <input
                type="radio"
                id="bitcoin"
                value="bitcoin"
                v-model="paymentMethod"
              />
              <label for="bitcoin" class="w-full pl-3 font-bold">
                <div class="payments-container__label">
                  <div class="in-row">
                    <span>{{ trans.bitcoin_title[lang] }}</span>
                  </div>
                </div>
              </label>
            </div>
            <div class="pl-6 mt-2">
              <p>{{ trans.bitcoin_description[lang] }}</p>
            </div>
          </div> -->
          <div class="radio-input">
            <div class="flex items-center">
              <input
                type="radio"
                id="transfer"
                value="transfer"
                v-model="paymentMethod"
              />
              <label for="transfer" class="w-full pl-3 font-bold">
                <div class="payments-container__label">
                  <div class="in-row">
                    <span>{{ trans.get('wizard.transfer_title') }}</span>
                  </div>
                </div>
              </label>
            </div>
            <div class="pl-6 mt-2">
              <p>{{ trans.get('wizard.transfer_description') }}</p>
              <transition name="fade">
              <div
                v-if="paymentMethod == 'transfer'"
                class="transfer-extra-info"
              >
                <div class="section">
                  <span class="title">{{trans.get('wizard.transfer_extra.account_holder') }}</span>
                  <img src='/img/icons/company.svg' alt='image-1' style='display:inline-block;' width='140' height='auto' loading='lazy'>
                </div>
                <div class="section">
                  <span class="title">{{trans.get('wizard.transfer_extra.account_number') }}</span>
                  <span class="text">ES31 3025 0012 1414 0012 6489</span>
                </div>
                <div class="section">
                  <span class="title">{{trans.get('wizard.transfer_extra.bic_entity') }}</span>
                  <span class="text">CDENESBBXXX:</span>
                </div>
                <div class="section">
                  <span class="title">{{trans.get('wizard.transfer_extra.concept') }}</span>
                  <span class="text">Número del pedido</span>
                  <span class="order-num">{{trans.get('wizard.transfer_extra.order_num') }}</span>
                </div>
                <div class="section">
                  <span class="warning">{{trans.get('wizard.transfer_extra.warning') }}</span>
                </div>
              </div>
              </transition>
            </div>
          </div>
        </div>
      </component-data>
      <!-- Saved cards component -->
      <!--                       -->
      <!-- Cart resume component -->
      <cart-resume class="mt-12">
        <btn-primary
          :disabled="!isValidCheckout"
          :handle-click="handleCheckout"
          class="mt-4"
          :text="trans.get('wizard.end')"
          :loading="loading"
        ></btn-primary>
      </cart-resume>
      <!--                       -->
    </div>
    <a
      href=""
      id="bitcoin-button"
      class="blockoPayBtn bitcoin-button"
      data-toggle="modal"
      :data-uid="bitcoinParam"
      ><img
        width="160"
        src="https://www.blockonomics.co/img/pay_with_bitcoin_medium.png"
    /></a>
  </div>
</template>

<script>
import CardComponent from "../common/CardComponent.vue";
import PaylandsComponent from "../common/PaylandsComponent.vue";
import DiscountComponent from "../coupon/InputCoupon.vue";
import axios from "axios";

import {
  GET_ADDRESS_DATA,
  SET_ADDRESS_DATA_MUTATION,
  GET_PERSONAL_DATA,
  SET_PERSONAL_DATA_MUTATION,
  GET_SHIPMENT_DATA,
  SET_SHIPMENT_DATA_MUTATION,
  GET_PERSONAL_VALID,
  GET_ADDRESS_VALID,
  STORE_ORDER_ACTION,
  GET_ORDER_LOADING,
  GET_PAYMENT_METHOD,
  SET_PAYMENT_METHOD,
  CREATE_PAYMENT_INSTANCE,
  GET_BITCOIN_PARAMS,
  GET_SELECTED_CARD_UUID,
  GET_REGIONS,
  RETREIVE_SHIPPING_TYPE,
  GET_SHIPPING_TYPE,
  SET_SELECTED_CARD_UUID,
  GET_FIELDS,
  GET_IS_CANARIAS
} from "../../../store/wizard/types";
import { GET_CART_COUNT, GET_SUBTOTAL, GET_IS_DISCOUNT_ACTIVE_IN_CART, GET_ITEM_SELECTOR } from "../../../store/cart/types";
import { mapActions, mapGetters, mapMutations } from "vuex";
import mixin from "../../../mixin";
import { phonePrefixes } from "../../../phonePrefixes";
import { findDiscountByQuantity, findTotalQuantityProductsDiscountPromoted, promotionDescription, promotionInfo, showPromotionItem, validBasicRequirement } from "../../../promotion/helper";
import PromotionCard from "../../cards/PromotionCard.vue";
import PrivacyRoute from "../common/PrivacyRoute.vue";
export default {
  mixins: [mixin],
  components: {
    DiscountComponent,
    PaylandsComponent,
    CardComponent,
    PromotionCard,
    PrivacyRoute,
  },
  data: () => {
    return {
      newsletterChecked: false,
      phonePrefixes: phonePrefixes,
      promotions: {},
      isCollapsed: true,
    }
  },
  computed: {
    ...mapGetters({
      addressForm: GET_ADDRESS_DATA,
      personalData: GET_PERSONAL_DATA,
      personalValid: GET_PERSONAL_VALID,
      addressValid: GET_ADDRESS_VALID,
      cartCount: GET_CART_COUNT,
      loading: GET_ORDER_LOADING,
      bitcoinParam: GET_BITCOIN_PARAMS,
      selectedCardUUID: GET_SELECTED_CARD_UUID,
      regions: GET_REGIONS,
      shippingType: GET_SHIPPING_TYPE,
      subtotal: GET_SUBTOTAL,
      isDiscountActive: GET_IS_DISCOUNT_ACTIVE_IN_CART,
      fields: GET_FIELDS,
      isCanarias: GET_IS_CANARIAS,
      items:GET_ITEM_SELECTOR,
    }),
    anyPromotionActive(){
        let anyPromotionActive = null;

        this.items.forEach(item => {
            if(this.showPromotionItem(item)) anyPromotionActive = true
        })

        return anyPromotionActive !== null
    },
    discountPromotionProducts() {
      return findTotalQuantityProductsDiscountPromoted(this.items);
    },
    shipingdata: {
      get() {
        return this.$store.getters[GET_SHIPMENT_DATA];
      },
      set(value) {
        this.setShipmentData(value);
      },
    },
    paymentMethod: {
      get() {
        return this.$store.getters[GET_PAYMENT_METHOD];
      },
      set(value) {
        this.setPaymentMethod(value);
      },
    },
    isValidCheckout() {
      return this.personalValid && this.addressValid && this.cartCount > 0;
    },
  },
  watch: {
    bitcoinParam: function (val) {
      const btn = document.getElementById("bitcoin-button");
      btn.setAttribute("data-uid", val);
      btn.click();
    },
    paymentMethod: function (val) {
      this.$store.commit(SET_SELECTED_CARD_UUID, 0);
    },
  },
  methods: {
    ...mapMutations({
      setAddressData: SET_ADDRESS_DATA_MUTATION,
      setPersonalData: SET_PERSONAL_DATA_MUTATION,
      setPaymentMethod: SET_PAYMENT_METHOD,
    }),
    ...mapActions({
      createPaymentInstance: CREATE_PAYMENT_INSTANCE,
      storeOrderAction: STORE_ORDER_ACTION,
      retreiveShippingType: RETREIVE_SHIPPING_TYPE,
    }),
    itemFinalPrice(item) {
        if (!item.attributes.promotion || item.attributes.promotion.type === 'basic') return item.price;

        const discount = findDiscountByQuantity(item.attributes.promotion, this.discountPromotionProducts);

        if (discount) return (1 - (discount / 100)) * item.price

        return item.price;
    },
    showPromotionItem(item){
        return showPromotionItem(item, this.discountPromotionProducts);
    },
    promotionDescription(item){
        return promotionDescription(item, this.discountPromotionProducts);
    },
    promotionInfo(item){
        return promotionInfo(item, this.discountPromotionProducts);
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    handlePhonePrefix(payload) {
        this.setPersonalData({
        ...this.personalData,
        phone_prefix: {
          ...this.personalData.phone_prefix,
          value: payload.code,
        },
      });
    },
    handlePersonalChange(payload) {
      this.setPersonalData({
        ...this.personalData,
        [payload.name]: {
          ...this.personalData[payload.name],
          value: payload.value,
        },
      });
    },
    handleCheckout() {
      if (!this.isValidCheckout) return;
      this.storeOrderAction({
        address: this.addressForm,
        personal: this.personalData,
        shipping: this.shippingType,
        newsletter: this.newsletterChecked,
        paymentMethod: this.paymentMethod,
      });
    },
  },
  mounted() {
    // window.onbeforeunload = () => {
    //   return this.trans.unsavedChanges[this.lang];
    // };
    this.retreiveShippingType(this.addressForm);

    if (this.$route.query.error) {
      this.$toast.open({
        message: trans.payment_error[this.lang],
        type: "error",
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "order-placed") {
      window.location.href = "/";
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
.bitcoin-button {
  display: none;
}

.transfer-extra-info{
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  .section{
    margin: 8px 0;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;

    .title{
      font-weight: bold;
    }

    .order-num{
      color: #dd6a00;
    }

    .warning{
      color: #3a473c;
      font-weight: bold;
      margin-top: 16px;
    }
  }
}
.payments-container {
  display: flex;
  flex-direction: column;
  .radio-input {
    margin-top: 2rem;
    label {
      font-size: 18px;
    }

    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
      position: absolute;
      left: -9999px;
    }
    [type="radio"]:checked + label,
    [type="radio"]:not(:checked) + label {
      position: relative;
      padding-left: 28px;
      cursor: pointer;
      line-height: 20px;
      display: inline-block;
      color: #000;
    }
    [type="radio"]:checked + label:before,
    [type="radio"]:not(:checked) + label:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 19px;
      height: 19px;
      border: 1px solid #ddd;
      border-radius: 100%;
      background: #fff;
    }
    [type="radio"]:checked + label:after,
    [type="radio"]:not(:checked) + label:after {
      content: "";
      width: 11px;
      height: 11px;
      background: #3a473c;
      position: absolute;
      top: 4px;
      left: 4px;
      border-radius: 100%;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }
    [type="radio"]:not(:checked) + label:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    [type="radio"]:checked + label:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

// Checkbox style
input.check-newsletter {
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.1em solid currentColor;
  border-radius: 0.4em;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;
}

input.check-newsletter::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em #3a473c;
  background-color: CanvasText;
}

input.check-newsletter:checked::before {
  transform: scale(1);
}

input.check-newsletter:focus {
  outline-offset: max(2px, 0.15em);
}

.rotate-180 {
  transform: rotate(180deg);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}


</style>
